import { Pipe, PipeTransform } from '@angular/core';

import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';
import { TabulationClassification, TabulationDatum } from '@mtna/rds-base-ui';

import { RdsCodeDisplayType } from '../core/models/code-display-type.model';
import { getDatumValue } from './models/datum-util';

@Pipe({
  name: 'rdsGetDatumValue'
})
export class RdsGetDatumValuePipe implements PipeTransform {
  /**
   * Returns a value for a given Datum.
   * The map should contain each display type & their associated property names, .i.e.
   * { 'NAME': ['name'], 'VALUE': ['codeValue'], 'BOTH': ['codeValue', 'name'] }
   * @example
   * {{ codeDisplay | rdsGetDatumValue : row.cells[i].datum : map }}
   * @param displayType RdsCodeDisplayType for which datum value type to show, if value is a Code
   * @param datum Datum containing the value to retrieve
   * @param map map of property names arrays inside a value object, should be indexed using codeDisplay
   */
  transform(
    displayType: RdsCodeDisplayType,
    datum: TabulationDatum<any>,
    variables: Array<Variable | VariableSummary>,
    classifications: { [id: string]: TabulationClassification },
    map: { [id: string]: string[] }
  ): any {
    if (!!map[displayType] && !!map[displayType].length) {
      return getDatumValue(datum, variables, classifications, ...map[displayType]);
    }
    return getDatumValue(datum, variables, classifications);
  }
}
